let lastActivity = Date.now();
let onActivity: (() => void) | null = null;

export const trackActivity = () => {
  lastActivity = Date.now();
  onActivity?.();
};

export const getLastActivity = () => lastActivity;

export const setActivityListener = (listener: (() => void) | null) => {
  onActivity = listener;
};
